import cafeImage from '../images/navi/categories/cafe.png'
import entertainmentVenueImage from '../images/navi/categories/entertainment_venue.png'
import filmingLocationImage from '../images/navi/categories/filming_location.png'
import landmarkImage from '../images/navi/categories/landmark.png'
import otherImage from '../images/navi/categories/other.png'
import practiceStudioImage from '../images/navi/categories/practice_studio.png'
import restaurantImage from '../images/navi/categories/restaurant.png'
import shopImage from '../images/navi/categories/shop.png'

const CATEGORY_IMAGES: Record<string, string> = {
  cafe: cafeImage,
  entertainment_venue: entertainmentVenueImage,
  filming_location: filmingLocationImage,
  landmark: landmarkImage,
  other: otherImage,
  practice_studio: practiceStudioImage,
  restaurant: restaurantImage,
  shop: shopImage,
}

export function getCategoryImage(category: string | null | undefined): string | null {
  if (!category) return null
  return CATEGORY_IMAGES[category] || null
}
